import { IBaseCDV3ViewItem } from '../interfaces/ICDViewItem';

export const sortByCreatedAt = (item1: Partial<IBaseCDV3ViewItem>, item2: Partial<IBaseCDV3ViewItem>) => {
  const NOW = Date.now();
  const item1Time = item1.created_at ? new Date(item1.created_at).getTime() : NOW;
  const item2Time = item2.created_at ? new Date(item2.created_at).getTime() : NOW;
  return item1Time - item2Time;
};
